export default __webpack_public_path__ + "static/basarili-mesaj-63f600319f050757319c4ac5d33e918d.png";